import { render, staticRenderFns } from "./EntityMappingTable.vue?vue&type=template&id=7912125a&"
import script from "./EntityMappingTable.vue?vue&type=script&lang=ts&"
export * from "./EntityMappingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports